export interface IFetchResponse {
	body: string;
	statusCode: number;
	headers: object;
}
